<div id="recovery-card" class="dx-card content">
  <dx-validation-group>
    <div class="recovery-header">
      <img class="logo" [height]="50" [src]="'/assets/images/tracagri_logo_color.svg'">
      <div class="text">Réinitialiser votre mot de passe.</div>
    </div>
    <div class="dx-field">
      <dx-text-box [(value)]="email" placeholder="Adresse e-mail" width="100%">
        <dx-validator>
          <dxi-validation-rule type="required"
                               message="Nous avons besoin d'une adresse e-mail pour vous envoyer le mot de passe"></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>
    <div class="dx-field">
      <dx-button type="default" text="Envoyer" (onClick)="onRecoveryClick($event)" width="100%"></dx-button>
    </div>
    <div class="dx-field">
      <a routerLink="/login">Se Connecter?</a>
    </div>
  </dx-validation-group>
</div>

<dx-load-panel
  shadingColor="rgba(0,0,0,0.2)"
  [position]="{ of: '#recovery-card' }"
  [(visible)]="loadIndicatorVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>
